/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import $ from 'n-zepto';
import Vue from 'vue/dist/vue.js'
import VueCompositionAPI from '@vue/composition-api'

Vue.use(VueCompositionAPI)

window.Vue = Vue;

import '../src/styles/app.scss';

import global from '../src/javascripts/common/global.js';
import home from '../src/javascripts/page/home.js'; this.home = home;
import storyline from '../src/javascripts/page/storyline.js'; this.storyline = storyline;
import characters from '../src/javascripts/page/characters.js'; this.characters = characters;
import shops from '../src/javascripts/page/shops.js'; this.shops = shops;
import shop from '../src/javascripts/page/shop.js'; this.shop = shop;
import miindex from '../src/javascripts/page/miindex.js'; this.miindex = miindex;
import mishow from '../src/javascripts/page/mishow.js'; this.mishow = mishow;
import events from '../src/javascripts/page/events.js'; this.events = events;
import whalegarden from '../src/javascripts/page/whalegarden'; this.whalegarden = whalegarden;

var page = $('main').data('event');
if (page) {
  this[page](); 
}



// WEBPACK FOOTER //
// app/javascript/packs/application.js